module.exports = __webpack_public_path__ + "img/pick4.80d61108.png";